import { Button } from '@arvoreeducacao/bonsai-ds'
import React from 'react'
import { getImageUrl } from 'utils/assets/Cdn'
import { useTranslation } from 'i18n'

const NewVersionBanner = () => {
  const { t } = useTranslation()
  const linkToForm =
    'https://docs.google.com/forms/d/e/1FAIpQLSccINB2Eelv6T4eZq-kEBeKK8UV71soDs0ZlE3ngG2zBC9boQ/viewform?usp=header'

  return (
    <div className="flex flex-col items-start p-6 gap-2.5 relative w-full">
      <div
        id="new-version-banner"
        className="flex flex-row items-center p-6 gap-4 w-full bg-primary-100 rounded-[20px] relative justify-between"
      >
        <div className="flex flex-row items-center gap-4 justify-start">
          <img
            src={getImageUrl('otto/otto-new-reports-v2.png')}
            alt="Otto"
            className="w-[110px] h-[83px]"
          />

          <div className="flex flex-col justify-center items-start p-0 gap-1 flex-1 ">
            <span className="font-bold text-[16px] leading-[130%] text-gray-700 m-0">
              {t('Uma nova versão dessa área está sendo desenvolvida')}
            </span>
            <span className="font-normal text-[14px] leading-[130%] text-gray-600 m-0">
              {t('Em breve você verá uma versão mais completa e atualizada.')}
            </span>
          </div>
        </div>

        <div className="flex flex-col justify-center items-center p-0 gap-2 flex-none">
          <span className="font-bold text-[16px] leading-[130%] text-gray-700 m-0 text-center">
            {t('Quer deixar uma sugestão?')}
          </span>
          <Button
            onClick={() => window.open(linkToForm, '_blank')}
            text={t('Queremos ouvir você!')}
            theme={{ type: 'secondary', size: 'medium' }}
          />
        </div>
      </div>
    </div>
  )
}

export default NewVersionBanner
